import ModalConfirmationVersement from "@/components/caisse/modal-confirmation";

import $ from "jquery";
export default {
    name: 'versements-en-attente',
    components: { ModalConfirmationVersement },
    props: [],
    data() {
        return {
            user_role: 0,
            user_role_id: 0,
            compte_id: 0,
            user_id: 0,
            sortBy: 'created_at',
            sortKey: 'no',
            sortDesc: true,
            operation_loading: true,
            operation_isempty: false,

            montant_selectionne: 0,
            idOp_selected: 0,
            fields: [
                "no",
                "Dates",
                "Heures",
                {
                    key: 'libelle',
                    label: 'Libellés'
                },
                "montant",
                "Action"
            ],
            perPage: 10,
            filter: "",
            currentPage: 1,
            operations: []
        }
    },
    computed: {
        userCredentials() {
            return this.$store.getters['authInfo'];
        },

        activeRole() {
            return this.$store.getters['activeRole'];
        },

        userCompte() {
            return this.$store.getters["compteActiveUser"];
        },
        rows() {
            return this.operations.length;
        },
    },
    mounted() {
        if (this.userCredentials.user.roles.length > 0) {
            this.user_id = this.userCredentials.user.id
            this.user_role = this.userCredentials.user.roles[0].nom;
            // this.user_role_id = this.userCredentials.user.roles[0].id;


            if (this.activeRole.nom == 'ROLE_CAISSIERE') {
                this.compte_id = 1
            } else if (this.activeRole.nom == 'ROLE_CAISSIERE_INTERMITENT') {
                this.compte_id = 4
            } else if (this.activeRole.nom == 'ROLE_COMPTABLE') {
                this.compte_id = 3
            } else {
                this.compte_id = 0
            }
        }

        setTimeout(() => {
            $(".p-content").fadeIn();
        }, 500);

        this.$store.dispatch("getVersementsEnAttenteByCompte", this.compte_id).then(
            (response) => {
                console.log("response", response)
                this.operation_loading = false;

                if (response.length > 0) {
                    this.operations = response
                } else {
                    this.operation_isempty = true;
                }

            }
        )
    },
    methods: {
        customDateFormat(given_date) {
            let only_date = "",
                only_hour = "";
            let date = new Date(given_date);
            let month = date.getMonth() + 1;
            only_date = date.getDate() + "/" + month + "/" + date.getFullYear();
            let c_hour = date.getHours();
            let c_minute = date.getMinutes();
            if (c_hour < 10) c_hour = "0" + c_hour;
            if (c_minute < 10) c_minute = "0" + c_minute;
            only_hour = c_hour + ":" + c_minute;

            return { date: only_date, hour: only_hour }

        },

        updateConfirmVersement() {
            this.$router.push({ name: 'Caisse' })
        },
    }
}